import { Component, OnInit } from "@angular/core";
import { SchedulerService } from "../../services/scheduler.service";
import { JobsLogsComponent } from "./joblogs/jobs.logs";
import { JobsQueueComponent } from "./queue/jobs.queue";

@Component({
    selector: 'jobs-settings',
    templateUrl: './jobs.settings.html',
    styleUrls: ['./jobs.settings.css']
})
export class JobsSettings implements OnInit {
    ngOnInit(): void {
      
    }
    constructor(private service: SchedulerService) {
    }

    static GetSettingsEntry() {
        return {
            Caption: '@@Jobs',
            ID: 'jobs',
            Icon: 'list-todo',
            Index: 6,
            Parent: 'about',
            Content: JobsSettings,
            Children: [
                {
                    Caption: '@@Logs',
                    ID: 'job-logs',
                    Icon: 'logs',
                    Index: 1,
                    Content: JobsLogsComponent
                },
                {
                    Caption: '@@Queue',
                    ID: 'job-queue',
                    Icon: 'queue',
                    Index: 2,
                    Content: JobsQueueComponent
                }
            ]
        }
    }
}